// Authentication utility functions for localStorage-based auth
export const AUTH_UNAUTHORIZED_EVENT = 'smart-portal:unauthorized';

export function getAuthToken(): string | null {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('authToken');
  }
  return null;
}

export function getUser(): any | null {
  if (typeof window !== 'undefined') {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }
  return null;
}

export function setAuthToken(token: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem('authToken', token);
  }
}

export function setUser(user: any): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem('user', JSON.stringify(user));
  }
}

export function clearAuth(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUserData');
    localStorage.removeItem('user');
  }
}

/** Notify the active auth provider that a protected API rejected the session. */
export function reportUnauthorized(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
  }
}

export function isAuthenticated(): boolean {
  return !!getAuthToken();
}

// Create axios headers with auth token
export function getAuthHeaders(): { [key: string]: string } {
  const token = getAuthToken();
  // console.log("getAuthHeaders token", token);
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    'Cache-Control': 'no-cache, no-store, must-revalidate',
  };
}
